import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=204f537d&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=204f537d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f537d",
  null
  
)

component.options.__file = "MainMenu.vue"
export default component.exports